 <template>
  <article class="reception-wrap">
    <scroller lock-x scrollbar-y use-pullup ref="scroller" :height="scrollerHeight" @on-pullup-loading="loadMore" :pullup-config="{content:'',upContent:'',downContent:'',loadingContent:'加载中...'}">
      <div class='record-content'>
        <group class="record-tips">
          <x-input placeholder='必填，如王先生' :max="10" v-model="record.customer_name">
            <div slot="label" class="record-tips__required weui_label"><span>客户姓名</span><em>*</em></div>
          </x-input>
          <input-number title='客户手机' placeholder='非必填，11位数字' :max="11" v-model="record.customer_mobile"></input-number>
          <x-input title='意向车型' placeholder="请输入" :max="10" v-model.trim="record.intention_car_model_name"></x-input>
          <interval-input title='购车预算' :valueL.sync='record.min_buy_car_budget' :valueR.sync='record.max_buy_car_budget'></interval-input>
          <selector title='意向等级' placeholder="请选择" :options="actionLevels" v-model="record.intention_level_id"></selector>
          <selector title='是否试驾' placeholder="请选择" :options="driveLists" v-model="record.is_test_drive"></selector>
          <selector title='来店类型' placeholder="请选择" :options="configTypes" v-model="record.arrival_type_id"></selector>
          <selector title='跟进结果' :options="resultList" v-model="record.follow_result"></selector>
        </group>
        <group>
          <x-switch title="到店提醒" v-model="record.is_arrival_notification"></x-switch>
        </group>
        <group class="record-history">
          <div class="record-history__title">
            <span class="title">历史记录</span>
            <span class="next-follow">下次跟进: &nbsp; {{noteInfo.latest_next_follow_at || '暂无'}}</span>
            <span class="add-note" @click.stop.prevent="handleAddNotes('add',customerId)">+新增笔记</span>
          </div>
          <ul class="record-history__list">
            <li v-for="(item,index) in noteList" :key="index" class="history-item">
              <!-- 左侧连接线 -->
              <vertical-flow :is-first='index === 0' :only-one='noteList.length === 1' :active-point='index === 0' :is-last='index === noteList.length - 1'></vertical-flow>
              <div class="history-item--content">
                <div class="history-item--title">
                  <span class="title-time">{{item.created_at}}</span>
                  <span class="title-desc">{{item.creator_name}}记录</span>
                </div>
                <p class="history-item--type">笔记类型：{{getNoteTxt(item.note_type)}}
                  <template v-if="item.plate_number">
                    【<em @click="previewImg(item.arrive_image)" :class="item.arrive_image && 'history-item--plate'">{{item.plate_number}}</em>｜{{item.arrive_time}}】
                  </template>
                </p>
                <p class="history-item--next">下次跟进：{{item.next_follow_at || '无'}}</p>
                <template v-if="item.note || (item.images&&item.images.length)">
                  <p class="history-item--note">{{item.note}}</p>
                  <img class="history-item--img" @click="previewImg(src)" v-for="(src,index) in item.images" :key="index" :src="src" alt="">
                </template>
                <div v-else class="history-item--addbutton" @click.stop.prevent="handleAddNotes('edit',item.id)">
                  补充笔记
                </div>
              </div>
            </li>
          </ul>
        </group>
        <!-- <divider class="bottom-line" v-if="loadCompleted">
          {{noteList.length >0 ?`共${noteList.length}条历史记录` : '暂无历史记录'}}
        </divider> -->
      </div>
    </scroller>
    <repeat-number-confirm v-model="confirmShow" :confirm='confirm'></repeat-number-confirm>
    <div class="fixed-bottom" ref="fixedBottom" @click.stop="onSubmit">保存资料</div>
  </article>
</template>

<script>
import {
  XTextarea,
  XSwitch,
  XInput,
  Toast,
  Scroller,
  Group,
  Selector,
  Confirm
} from '@lx-frontend/cvux'
import VerticalFlow from '../components/VerticalFlow'
import InputNumber from '../components/InputNumber'
import RepeatNumberConfirm from '../components/RepeatNumberConfirm'
import { mapActions, mapState } from 'vuex'
import IntervalInput from '../components/IntervalInput'
import { driveLists, resultList, initPage, noteTypes } from '../../common/professionalData'
import carRegisterMixins from '../mixins/carRegister.mixins'
import util from '@/common/util'
export default {
  components: {
    XInput,
    XSwitch,
    Scroller,
    Group,
    Selector,
    VerticalFlow,
    IntervalInput,
    InputNumber,
    RepeatNumberConfirm
  },
  mixins: [carRegisterMixins], // 包含了validatorForm formatParams
  computed: {
    ...mapState('salesReceptions', ['actionLevels', 'configTypes', 'customerInfo'])
  },
  data() {
    return {
      driveLists,
      resultList,
      customerId: '',
      images: [],
      record: {
        customer_name: '',
        customer_mobile: '',
        intention_car_model_name: '',
        min_buy_car_budget: '',
        max_buy_car_budget: '',
        intention_level_id: '',
        is_arrival_notification: '',
        is_test_drive: '',
        arrival_type_id: '',
        follow_result: ''
      },
      params: {
        ...initPage
      },
      noteInfo: {},
      noteList: [],
      noteTotal: '',
      isSubmit: false,
      confirmShow: false,
      confirm: {
        title: '号码已绑定',
        desc: '',
        fromCustomerId: '',
        toCustomerId: '',
        type: 'edit'
      },
      scrollerHeight: '',
      loadCompleted: false // 笔记记录下拉加载是否完成
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.scrollerHeight = `-${this.$refs.fixedBottom.offsetHeight}px`
  },
  watch: {
    // 只改变query达到重新跳转当前页面
    '$route'(to, from) {
      this.init()
    }
  },
  methods: {
    ...mapActions('salesReceptions', ['fetchAllConfigs', 'fetchCustomerInfo']),
    async init() {
      // eslint-disable-next-line
      const { customerId, plate_number } = this.$route.query
      this.params = { ...initPage }
      this.switchLoading({ status: true, text: '加载中...' })
      await this.fetchAllConfigs()
      // eslint-disable-next-line
      await this.fetchCustomerInfo({ customerId, plateNumber: plate_number })
      this.customerId = this.customerInfo.customer_id
      this.initCustomerInfo()
      await this.getNotes()
      this.switchLoading({ status: false })
    },
    initCustomerInfo() {
      Object.keys(this.record).forEach(key => {
        const val = this.customerInfo[key]
        this.record[key] = [null, undefined].includes(val) ? '' : val
        // 特殊情况，当意向等级和来店类型被删除的时候 要展示请选择
        if (key === 'arrival_type_id') {
          this.record[key] = this.configTypes.some(type => type.key === val) ? val : ''
        }
        if (key === 'intention_level_id') {
          this.record[key] = this.actionLevels.some(level => level.key === val) ? val : ''
        }
        if (['min_buy_car_budget', 'max_buy_car_budget'].includes(key)) {
          this.record[key] = util.fenToWan(val)
        }
      })
    },
    handleAddNotes(type, id) {
      this.$router.push({
        path: '/carregister/addNotes',
        query: { type, id }
      })
    },
    loadMore(done) {
      if (this.noteTotal > this.noteList.length) {
        this.params.page++
        this.$rest.carRegister.getNotes(this.customerId)(this.params).then(res => {
          if (res.code === 0) {
            let data = res.data
            this.totalCount = data.total_count
            this.noteList.push(...data.notes)
            this.$nextTick(() => {
              this.$refs.scroller.reset()
            })
            done(100)
          } else {
            this.showToast(res.message)
          }
          this.$nextTick(() => { this.$refs.scroller.enablePullup() })
        })
      } else {
        this.loadEnd()
        this.$nextTick(() => { this.$refs.scroller.reset() })
        done()
      }
    },
    loadEnd() {
      this.loadCompleted = true
      this.$refs.scroller.disablePullup()
    },
    async getNotes() {
      const res = await this.$rest.carRegister.getNotes(this.customerId)(this.params)
      if (res.code !== 0) {
        this.showToast(res.message || '未知错误')
        return
      }
      // eslint-disable-next-line
      const {total_count, notes} = res.data
      this.noteInfo = res.data
      this.noteList = notes
      // eslint-disable-next-line
      this.noteTotal = total_count
      // eslint-disable-next-line
      if ([0,this.noteList.length].includes(total_count)) {
        this.loadEnd()
      }
      this.$nextTick(() => { this.$refs.scroller.reset() })
    },
    previewImg(image) {
      if (!image) return
      this.$wechat.promise.then(wechat => {
        wechat.wx.previewImage({
          current: image, // 当前显示图片的http链接
          urls: [image] // 需要预览的图片http链接列表
        })
      }, wechat => {
        window.console.log('微信JSSDK校验错误:', JSON.stringify(wechat.res))
      })
    },
    async onSubmit() {
      if (this.isSubmit) return
      if (!this.validatorForm(this.record)) return
      const params = { ...this.record }
      this.formatParams(params, ['min_buy_car_budget', 'max_buy_car_budget'])
      this.isSubmit = true
      const res = await this.$rest.carRegister.editSalesCustomer(this.customerId)(params)
      this.isSubmit = false
      const { code } = res
      if (![0, 1404].includes(code)) {
        this.$message.fail(res.message || '未知错误')
        return
      }
      if (code === 1404) {
        this.submitErrorCB(res)
        return
      }
      this.$message.success('保存客户资料成功')
    },
    submitErrorCB(res) {
      this.confirm = {
        title: '号码已绑定',
        desc: res.message,
        fromCustomerId: +this.customerId,
        toCustomerId: res.data.customer_id,
        type: 'edit'
      }
      this.confirmShow = true
    },
    getNoteTxt(type) {
      return noteTypes.find(item => item.key === type).value || ''
    }
  }

}
</script>

<style lang="less">
@import '../../stylesheets/modules/carRegister/record.less';
</style>
